// Our Components
import SimpleAssetsSection from 'components/Analytics/Assumptions/SimpleAssetsSection';

function SimpleAssetsTable({
	investmentAccountPresentValue,
	setInvestmentAccountPresentValue,
	investmentAnnualGrowth,
	setInvestmentAnnualGrowth,
	propertyPresentValue,
	setPropertyPresentValue,
	propertyGrowthRate,
	setPropertyGrowthRate
}) {
	return (
		<>
			<SimpleAssetsSection
				sx={{ marginTop: 2, marginBottom: 2, display: 'block' }}
				title="Investment Account"
				presentValue={investmentAccountPresentValue}
				setPresentValue={setInvestmentAccountPresentValue}
				annualGrowth={investmentAnnualGrowth}
				setAnnualGrowth={setInvestmentAnnualGrowth}
			/>

			<SimpleAssetsSection
				sx={{ marginTop: 2, marginBottom: 2, display: 'block' }}
				title="Property"
				presentValue={propertyPresentValue}
				setPresentValue={setPropertyPresentValue}
				annualGrowth={propertyGrowthRate}
				setAnnualGrowth={setPropertyGrowthRate}
			/>
		</>
	);
}

export default SimpleAssetsTable;
